<span class="tag is-large"  [ngClass]="(presence$ | async )?.status">
    <span class="dot"></span>
</span>

